import Vue from "vue"
import navigation from "@js/navigation"
import appInteraction from "@/common/appInteraction"
import tools from '@/common/tools';

//设置title
Vue.directive('title',(el,binding)=>{
    document.title = binding.value;
})
//跳转页面
Vue.directive('href',{
    bind: function(el,binding) {
        if(binding.value){
            el.href = binding.value;
            el.onclick = function() {
                navigation.go(this.href);
            }
        }
    },
    update:function(el,binding){
        el.href = binding.value;
    }
})
//添加按下样式
Vue.directive('pressed',{
    bind: function(el) {
        el.onmousedown = function(){
            el.classList.add("pressed");
            window.onmouseup = function(){ 
                el.classList.remove("pressed");
                window.onmouseup = null;
            }
        };
        el.ontouchstart = function(){
            el.classList.add("pressed");
            window.ontouchend = function(){
                el.classList.remove("pressed");
                window.ontouchend = null;
            };
        };
    }
})
//数字取整
Vue.directive('integer',{
    bind: function(el) {
        el.oninput = function(){
            let value = el.value.replace(/^(0+)|[^\d]+/g,'');
            el.value = value;
        };
    }
})
//元素滚动记录
Vue.directive('scroll',{
    bind: function(el,{value,expression},vNode) {
        var keys = expression.split('.'),
            len = keys.length;
        var obj = vNode.context._data;
        if(len > 1){
            for(var i = 0;i < len-1;i++){
                obj = obj[keys[i]];
            }
        }
        el.onscroll=function(){
            let scroll = el.scrollTop;
            obj[keys[len - 1]] = scroll;
        }
    },
    update:function(el,{value}){
        var scroll = 0;
        if(el.scrollHeight > el.clientHeight){
            if(el.scrollHeight - el.clientHeight > value){
                scroll = value;
            }else{
                scroll = el.scrollHeight - el.clientHeight;
            }
        }
        el.scrollTop = scroll;
        el.onscroll();
    }
})
//元素阴影滚动时出现
const scrollShadowFn = function(el,{value}){
    if(typeof value == 'boolean' && value){
        el.style.boxShadow = `0 0.04rem 0.12rem 0.02rem rgba(216,220,228,0.76)`;
    }else if(value > 0){
        let n = value / 260 * 0.76;
        n = n > 0.76 ? 0.76 : n;
        el.style.boxShadow = `0 0.04rem 0.12rem 0.02rem rgba(216,220,228,${n})`;
    }else{
        el.style.boxShadow = '';
    }
}
Vue.directive('scrollShadow',{
    bind: scrollShadowFn,
    update: scrollShadowFn
})
//分享
const shareFn = function(el,{value}) {
    el.onclick = function(){
        appInteraction.share(value);
    }
}
Vue.directive('share',{
    bind: shareFn,
    update: shareFn
})
//根据手机高度对证书进行显示缩放
Vue.directive('certificateScale', {
    bind: function(el, {value = {}}) {
        var { 
                margin = tools.remToPx(386),
                height = tools.remToPx(972),
                minScale = 0.7,
                maxScale = 1 
            } = value;
        var scale = (document.body.clientHeight - margin) / height;
        el.style.setProperty('--scale', scale > maxScale ? maxScale : scale < minScale ? minScale : scale);
    }
});